import { IControlNameExpression } from './control-name-expression';
import { ISelectOptionGroup } from './select-option-group';
import { IDynamicFormControl } from './dynamic-form-control';

// Information retrieved from the server
export interface IDynamicForm {
  formControls: IDynamicFormControl[];
  selectOptionGroups: ISelectOptionGroup[];
  requiredExpressions: IControlNameExpression[];
  additionalValidationExpressions: IControlNameExpression[];
  fullValidators: DynamicFormValidators[];
  expressions: Map<string, string>;
}

export enum DynamicFormValidators {
  AtLeastOneRequired = 'AtLeastOneRequired',
  ExactNumberOfFieldsRequired = 'ExactNumberOfFieldsRequired',
}
